import React from 'react';
import * as styles from './Scroller.module.scss';

export default function Scroller({ scrollerKey, className }) {
  const handleClick = () => {
    const scrollTarget = document.getElementById(scrollerKey);
    scrollTarget.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <button className={className} onClick={handleClick} aria-label='Go down'>
      <svg
        className={styles.icon}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 36"
      >
        <path d="M0,0l15,16L30,0"></path>
        <path d="M0,10l15,16l15-16"></path>
        <path d="M0,20l15,16l15-16"></path>
      </svg>
    </button>
  );
}
